export const MAX_ZOOM = 16;
export const CENTER = { lat: 40.68595, lng: -73.89884 }; // { lat: LOCATIONS[0].lat, lng: LOCATIONS[0].lng }
export const LOCATIONS = [
    {
        title: 'Will and Herta Geer\'s Apartment',
        address: 'West 59th Street at 5th Avenue',
        addressTruncated: 'West 59th Street at 5th Avenue',
        address2: 'Midtown Manhattan',
        lat: 40.76428,
        lng: -73.97304,
        dates: ['FEBRUARY 16 – 22, 1940'],
        mp3: 'My Name Is New York - Location 01.mp3',
        mp3Length: '00:05:07',
        bandcampURL: 'https://woodyguthriemusic.bandcamp.com/track/location-01-59th-street-at-5th-avenue',
        imgCredit: 'Will & Herta Geer’s apartment building, where Woody Guthrie first came to stay in NYC, February 16, 1940.',
        description: (
            <div>
                <p>Woody Guthrie first arrived in New York City on a cold, blizzardy day—February 16th, 1940—after hitchhiking across the country from Los Angeles. He took up residence on West 59th Street with friends, actors Will and Herta Geer, whom he first met in Los Angeles in 1939. Will Geer, years later well-known for his TV role as Grandpa Zebulon Walton in The Walton’s, had come to NYC to star in the Broadway production of Erskine Caldwell’s Tobacco Road.</p>
                <p>While in Los Angeles, Geer was incredibly influential, introducing Woody to the various political and labor movements. He also helped get him work, including a bit part as an extra in Pare Lorentz’s 1940 film The Fight for Life. (In a five second shot, a 27-year-old Woody Guthrie sits on a stoop, strumming a guitar. The guitar part was later overdubbed by a “professional”).</p>
                <p>The Geers provided Woody with a couch to crash on, and connected him to the progressive NYC entertainment community. As a result of Geer’s efforts, Woody was booked into several benefit concerts; perhaps most importantly the “Grapes of Wrath Evening” to benefit the John Steinbeck Committee for Agricultural Workers at the Forrest Theatre (230 West 49th Street, now the Eugene O’Neill Theatre) on March 3rd, where he met some of the most important people in the burgeoning folk scene: Lead Belly, Pete Seeger, Harlan County coal mining organizer Aunt Molly Jackson, and Alan Lomax who worked at the Library of Congress.</p>
                <p>Excited by Woody’s performance, and his discovery of a new, “authentic” voice from the West writing original material, Lomax immediately invited Woody to Washington, D.C. In March, 1940 he recorded hours worth of stories and songs about Woody’s life and travels for the Library. The Library of Congress Recordings were eventually released in 1964.</p>
                <p>While living at the Geers’, Woody spent his days writing songs like <b>I Don’t Feel at Home on the Bowery No More</b>, and his evenings earning a few bucks gigging at bars along the Bowery and 10th Avenue where the merchant seamen hung out. When he had earned enough for a week’s lodging, he moved over to Hanover House located at 6th Avenue and 43rd Street, taking Herta’s prized Martin guitar with him.</p>
                <p>Written while at the Geers’, Woody’s lyric, <b>I Don’t Feel At Home On The Bowery No More</b>, gives us a nice portrait of this elegant apartment building, which no longer stands, and describes Woody’s reaction to finding himself living in NYC’s finest: “I seen an apartment on 5th Avenue/a penthouse, and garden, a skyscraper view/A carpet so soft, with a hard-wood floor/I don’t feel at home on the Bowery no more.”</p>
                <p></p>
            </div>
        ),

    },
    {
        title: 'Hanover House',
        address: '101 West 43rd Street (northwest corner of 6th Avenue)',
        addressTruncated: '101 West 43rd Street',
        address2: 'Midtown Manhattan',
        lat: 40.75583,
        lng: -73.98378,
        dates: ['FEBRUARY 22 – MARCH, 1940'],
        mp3: 'My Name Is New York - Location 02.mp3',
        mp3Length: '00:04:42',
        imgCredit: 'Hanover House, the boarding house where Woody Guthrie lived and penned “This Land Is Your Land” on February 23, 1940.',
        description: (
            <div>
                <p>Standing on the corner of 43rd and 6th Avenue now, it’s hard to imagine that this urban landscape filled with modern skyscrapers was once populated by cigar and dry goods shops, cheap transient hotels, and overflowing street cars. In late February 1940, Woody moved into Hanover House—the boarding house that once stood above a tuxedo shop on this corner. It was here, on February 23rd, 1940, that 27-year-old Woody Guthrie sat in his room and wrote down the words to a new song: <b>This Land Was Made For You And Me</b> (popularly known as <b>This Land Is Your Land</b>).</p>
                <p>The words for the song were actually brewing in his mind during the month it took to hitchhike from Los Angeles to New York. Kate Smith’s recording of Irving Berlin’s “God Bless America” was blaring out of every jukebox and radio across the country. Woody penned <b>This Land</b> as a personal response. His eyewitness account of both the beauties of the land and the hard times of the people he met on his journey east questioned the idea that America was “blessed.” To Woody, it seemed like much of it was suffering. He believed it was up to the people themselves to work towards making these “blessings”—like freedom, justice, and equality—a reality.</p>
                <p>Originally titled <b>God Blessed America</b>, the song was re-titled a few years later. <b>This Land Is Your Land</b> did not become popular until its publication in a songbook in 1950 when it was taken up by public school music teachers and often performed by Pete Seeger. Ironically, Seeger had been blacklisted at the time, and could only make a scarce living performing at schools and summer camps. Seeger always included This Land in his concerts and it was through this small, grassroots movement that the song became known to every child in America, the next generation of folk and rock musicians, political activists, and (even) politicians!</p>
                <p>Before signing his name at the bottom of the finished lyric, Woody wrote, “All you can write is what you see.” Other songs written at Hanover House include <b>Talking Subway Blues</b>, <b>Jesus Christ</b> and <b>Wimmen’s Hat’s</b>. They reveal Woody’s first impressions of the city, looking out over a bustling Times Square from a cheap boarding house window.</p>
            </div>
        ),
    },
    {
        title: 'Jerry Oberwager\'s Apartment',
        address: '57 East 4th Street, 6th Floor',
        addressTruncated: '57 East 4th Street',
        address2: 'East Village, Manhattan',
        lat: 40.72704,
        lng: -73.99093,
        dates: ['ONE NIGHT IN APRIL, 1940'],
        mp3: 'My Name Is New York - Location 03 - Preview.mp3',
        mp3Length: '00:00:40',
        imgCredit: 'Original album cover to “Dust Bowl Ballads,” Woody Guthrie’s first recording and included his song “Tom Joad”, written at Jerry Oberwager’s apartment in NYC, April, 1940.',
        description: (
            <div><p>Although Woody never lived in this apartment, he did spend one very productive night here!
                After hearing Woody’s performance at the Forrest Theatre on March 3rd, Alan Lomax vigorously supported Woody’s career. He persuaded Victor Records to produce a two-volume, eleven song set of Woody’s <b>Dust Bowl Ballads</b>. As part of the project, Victor asked Woody to write a new song based on the current, popular film The Grapes of Wrath based on John Steinbeck’s novel and starring Henry Fonda. Woody went out and watched the film—which was playing at the Rivoli Theatre from January 24th to March 31st—twice through. A few days later he asked Pete Seeger if he might borrow his typewriter…</p>
            </div>
        ),
    },
    {
        title: 'Harold Ambellan and Elisabeth Higgins',
        address: '31 East 21st Street, 3B',
        addressTruncated: '31 East 21st Street',
        address2: 'Flatiron District, Manhattan',
        lat: 40.73963,
        lng: -73.98848,
        dates: ['APRIL, MAY, & OCTOBER 1940'],
        mp3: 'My Name Is New York - Location 04 - Preview.mp3',
        mp3Length: '00:00:40',
        imgCredit: '“Ballad Night!” flyer invitation to a house performance featuring Burl Ives, Woody Guthrie, among others at their home at 31 East 21st Street, NYC.',
        description: (
            <div>
                <p>
                    Woody returned to New York in April 1940, following his visit to Washington, D.C., where he recorded his songs and stories for the Library of Congress with Alan Lomax. While in Washington, he struck up an easy friendship with Pete Seeger who was then also working for the Library.

                    Seeger returned to NYC with Woody, who took up residence with Harold Ambellan and his wife Elisabeth Higgins here in their top floor loft. Both Ambellan and Higgins were artists and political activists, creating sculptures and ceramic tiles, as well as musical and literary works. They were among a new generation of young NYC artists who began combining their working studio with their living space…
                </p>
            </div>
        ),
    },
    {
        title: 'Woody and Mary Guthrie\'s Apartment',
        address: '5 West 101st Street, 4th Floor',
        addressTruncated: '5 West 101st Street',
        address2: 'Upper West Side, Manhattan',
        lat: 40.7953,
        lng: -73.96292,
        mp3: 'My Name Is New York - Location 05 - Preview.mp3',
        mp3Length: '00:00:40',
        dates: ['November 1940 – January 1941'],
        imgCredit: 'Woody & Mary Guthrie’s apartment building, where they lived with their three children; Gwen, Sue, and Bill. This building still stands.',
        description: (
            <div><p>
                Following the release of <b>Dust Bowl Ballads</b> in the summer of 1940, Woody received offers to appear on numerous NYC radio shows: CBS’s Model Tobacco Company’s Back Where I Come From and Pipe Smoking Time; Sanka’s We, The People; NBC’s Cavalcade of America; and appearances on WNYC, New York’s public radio. He wrote to Alan Lomax, “They’re giving me money so fast, I’m using it to sleep under.” In the short time since his arrival, Woody Guthrie had become a New York City success story. With money and critical acclaim pouring in, and his popularity growing, he sent for his wife Mary and their three young children, Gwen, Sue, and Bill, who were living in Pampa, Texas…
            </p>
            </div>
        ),
    },
    {
        title: 'Almanac House #1',
        address: '70 East 12th Street, 5th Floor aka “The Loft”',
        addressTruncated: '70 East 12th Street',
        address2: 'East Village, Manhattan',
        lat: 40.73274,
        lng: -73.99037,
        dates: ['June 24 – July 8, 1941'],
        mp3: 'My Name Is New York - Location 06 - Preview.mp3',
        mp3Length: '00:00:40',
        imgCredit: 'The Almanac Singers (l to r) Woody Guthrie, Millard Lampell, Bess Lomax Hawes, Pete Seeger, Lee Hays, and Sis Cunningham who lived together at Almanac House #1 for a couple of weeks in 1941.',
        description: (
            <div>
                <p>
                    After completing his work for the Bonneville Power Administration on June 11th, 1941, Woody returned to New York City to join up with Pete Seeger and a new group he was forming called the Almanac Singers.
                </p>
                <p>
                    The Almanac Singers—Seeger, Lee Hays, Pete Hawes, and Millard Lampell—lived communally in a now-defunct loft they called “Almanac House,” sharing expenses and collaborating on lyrics. The group focused on union, labor, and peace songs.
                </p>
                <p>
                    A gathering place for New York’s progressives, Almanac House regulars included artist Rockwell Kent, writer Dashiell Hammett, poet Walter Lowenfels, and composer Marc Blitzstein.
                </p>
                <p>
                    While hitchhiking to New York on June 22nd, 1941, Woody heard the news flash. Hitler had broken the Soviet-Axis Pact and Germany was pushing into the Soviet Union. As Seeger remembers, “Woody knocked on the door and when I open it he announced, ‘Well, I guess we’re not gonna be singing any more of them peace songs.’…
                </p>
            </div>
        ),
    },
    {
        title: 'Almanac House #2',
        address: '130 West 10th Street',
        addressTruncated: '130 West 10th Street',
        address2: 'Greenwich Village, Manhattan',
        lat: 40.7345,
        lng: -74.0003,
        dates: ['October 1941 – January 1942'],
        mp3: 'My Name Is New York - Location 07 - Preview.mp3',
        mp3Length: '00:00:41',
        numImages: 2,
        imgCredit: 'The Almanac Singers apartment building, where the Almanac Singers lived for a few months at the end of 1941 and which still stands.',
        description: (
            <div>
                <p>
                    This three-story row house at 130 West 10th Street, located next door to Squad 18’s firehouse, was the second home to the Almanac Singers, a loose collective of musicians living, composing, and performing together. The ever-changing members of the group included Pete Seeger, Lee Hays, Millard Lampell, Bess Hawes, Sis Cunningham, Pete and Butch Hawes, Josh White, Cisco Houston, Lead Belly, and Woody Guthrie. Woody’s bedroom was on the second floor.
                </p>
                <p>
                    1941 was an exciting time for the Almanacs. Folk music was beginning to make it’s way into New York City life and the group was getting up to six bookings a day. Almanac House was a beehive of non-stop activity: blues musicians Sonny Terry and Brownie McGhee were temporary residents; Joe Hill’s “Rebel Girl” and IWW activist Elizabeth Gurley Flynn brought Hill’s private papers for the Almanacs to read; trade union organizer Mother Bloor provided fresh vegetables from her garden; and Nicholas Ray (director of Rebel Without a Cause starring James Dean) wrote and directed CBS radio shows for his Almanac roommates. They hosted Sunday afternoon performances in the basement, coining the term “hootenanny.”…
                </p>
            </div>
        ),
    },
    {
        title: 'Almanac House #3',
        address: '430 6th Avenue, 2nd Floor',
        addressTruncated: '430 6th Avenue',
        address2: 'Greenwich Village, Manhattan',
        lat: 40.7429,
        lng: -73.9928,
        dates: ['January – July, 1942'],
        mp3: 'My Name Is New York - Location 08 - Preview.mp3',
        mp3Length: '00:00:40',
        imgCredit: 'The Almanac Singers lived in the second-floor apartment of this now defunct building, for 6 months in early 1942.',
        description: (
            <div>
                <p>
                    When the Almanac Singers were evicted from their townhouse at 130 West 10th Street for failure to pay the rent, they moved under cover of night to a loft at this now-defunct address: a second-floor apartment above Luigi’s Restaurant and the Dome dancehall.
                </p>
                <p>
                    The U.S. declared war against Japan on December 8th, 1941, one day after the attack on Pearl Harbor. On December 11th, Germany declared war against the U.S. Woody’s writing now took on a serious urgency, eagerly documenting the stories of the men and women who were thrust into the war effort. The newspaper headlines fueled his writing. <b>Normandie Was Her Name</b> paid tribute to the French ocean liner destroyed in a fire while being converted into a troopship in NYC’s harbor. <b>Miss Pavlichencko</b> heralded the Russian sniper who fought against the fascists…
                </p>
            </div>
        ),
    },
    {
        title: 'Marjorie Mazia\'s Apartment',
        address: '148 West 14th Street, 3rd Floor, Room 14',
        addressTruncated: '148 West 14th Street',
        address2: 'Greenwich Village, Manhattan',
        lat: 40.73803,
        lng: -73.99918,
        dates: ['March – September 1942'],
        mp3: 'My Name Is New York - Location 09 - Preview.mp3',
        mp3Length: '00:00:48',
        imgCredit: 'Door front to Marjorie Mazia’s apartment building, which still stands. Woody began drafting his autobiography, “Bound For Glory” at this location.',
        description: (
            <div>
                <p>
                    Although Woody Guthrie and Marjorie Mazia were both married to others, Woody spent most of his time here from March to September 1942. Having just received a contract from E.P. Dutton to write his autobiography, it was here that Woody began to work in earnest not as a songwriter, but as a literary writer.
                </p>
                <p>
                    Having met Woody through their work together in the dance program Dust Bowl Ballads, Marjorie invited Woody to use her apartment during the day while she was teaching or away on tour with the Martha Graham Dance Company. Almanac House had become too distracting with its visitors and activities. It was here that Woody found the solitude and structure he needed to focus on his writing…
                </p>
            </div>
        ),
    },
    {
        title: 'Almanac House #4',
        address: '647 Hudson Street, “2 flights up”',
        addressTruncated: '647 Hudson Street',
        address2: 'Greenwich Village, Manhattan',
        lat: 40.73924,
        lng: -74.00571,
        dates: ['July 1942 – November 1942'],
        mp3: 'My Name Is New York - Location 10 - Preview.mp3',
        mp3Length: '00:00:43',
        imgCredit: 'Door front to Gordon Friesen and Sis Cunningham’s second-floor apartment, where the Almanac Singers lived for a few months in 1942.',
        description: (
            <div>
                <p>
                    When Marjorie Mazia returned to Philadelphia, Woody moved back in with the current band of Almanac Singers, now stationed at 647 Hudson Street.
                </p>
                <p>
                    This last incarnation of Almanac House was more Gordon Friesen and Sis Cunningham’s apartment. Friesen and Cunningham would later publish the innovative 1960s topical song magazine Broadside, which was the first to publish songs by Bob Dylan, Phil Ochs, Tom Paxton, and other emerging folksingers. (Dylan’s “Talking John Birch Society Blues” was published in the very first issue).
                </p>
                <p>
                    As the U.S. involvement in WWII escalated, the Almanac Singers found themselves in a difficult position. Publically known for their earlier performances of peace songs, as well as for their support of left-leaning politics, the group was now finding it almost impossible to get work.
                </p>
                <p>
                    Woody, however, was flooded with new words…
                </p>
            </div>
        ),
    },
    {
        title: 'El Rancho del Sol',
        address: '74 Charles Street, Apt. 5 FE',
        addressTruncated: '74 Charles Street',
        address2: 'Greenwich Village, Manhattan',
        lat: 40.73476,
        lng: -74.00362,
        dates: ['December 1942 – May 1943'],
        mp3: 'My Name Is New York - Location 11 - Preview.mp3',
        mp3Length: '00:00:46',
        imgCredit: 'Door front to Woody’s first real home in NYC. This fourth floor, $27-a-month, walk-up apartment still stands, in the heart of Greenwich Village, NYC.',
        description: (
            <div>
                <p>
                    In December, Woody moved into this fourth floor, $27-a-month, walk-up apartment. This was Woody Guthrie’s first real home in New York City, where he alone signed the lease and paid the rent.
                </p>
                <p>
                    Although Marjorie Mazia was still living with her husband in Philadelphia, she came to NYC often enough for them to consider this their first home together. They jokingly nicknamed it “El Rancho del Sol.” Believing that Marjorie and their newborn daughter Cathy Ann would eventually come to live with him here, Woody was happy, upbeat, and hopeful.
                </p>
                <p>
                    With the Almanac Singers basically disbanded—its members no longer in town—Woody decided to create a new group of his own. Woody Guthrie’s Headline Singers included blues musicians Sonny Terry, Brownie McGhee, and Lead Belly…
                </p>
            </div>
        ),
    },
    {
        title: 'Woody and Marjorie\'s Apartment',
        address: '3815 Atlantic Avenue, 2nd Floor',
        addressTruncated: '3815 Atlantic Avenue',
        address2: 'Sea Gate, Brooklyn',
        lat: 40.57388,
        lng: -74.00492,
        dates: ['June – October 1943'],
        mp3: 'My Name Is New York - Location 12 - Preview.mp3',
        mp3Length: '00:00:46',
        imgCredit: 'Woody and Marjorie Guthrie, 1946',
        description: (
            <div>
                <p>
                    Although one cannot enter Sea Gate without a resident’s pass, this location is worth noting. (Stand on the rock jetty at West 37th Street and peek over.)
                </p>
                <p>
                    In June 1943, Marjorie and Cathy Ann “Stackabones” Guthrie moved up from Philadelphia and into this small room in Sea Gate, Coney Island, right above Marjorie’s parents Isadore and Aliza Greenblatt. Marjorie’s decision was made, and she would now live with Woody and their daughter as a family.
                </p>
                <p>
                    Quite frankly, Marjorie’s Jewish parents were appalled by the decision, and equally unimpressed with the man. He was a gentile, he didn’t earn a regular income, he was unreliable, undependable, and generally every other “un-able” they could think of. And worse, both Marjorie and Woody were still officially married to others…
                </p>
            </div>
        ),
    },
    {
        title: 'The Guthries\' Apartment',
        address: '3520 Mermaid Avenue, Apt. #1R',
        addressTruncated: '3520 Mermaid Avenue',
        address2: 'Coney Island, Brooklyn',
        lat: 40.5746,
        lng: -74.00126,
        dates: ['November 1943 – September 1950'],
        mp3: 'My Name Is New York - Location 13 - Preview.mp3',
        mp3Length: '00:00:55',
        numImages: 2,
        imgCredit: 'Although no longer standing, 3520 Mermaid Avenue is the most well-known of all Woody’s NYC addresses. The Guthrie Family lived at this first-floor, rear apartment for seven years. In 2019 the street was renamed, Woody Guthrie Way.',
        description: (
            <div>
                <p>
                    Although the house in which they lived no longer stands (a senior citizens home now takes its place), Woody moved to the first-floor, rear apartment at this location with Marjorie and their young daughter Cathy Ann in November 1943. Their children Arlo, Joady, and Nora were all born here.
                </p>
                <p>
                    This location has become the most well-known of all Woody’s NYC addresses, perhaps due to Billy Bragg and Wilco’s popular Mermaid Avenue albums, which set new music to Woody’s unrecorded lyrics. Or perhaps because Woody lived here for such an extraordinary amount of time—seven years…
                </p>
            </div>
        ),
    },
    {
        title: 'Woody and Marjorie\'s Beach Haven Apartment',
        address: '49 Murdock Court, Apt. #1J',
        addressTruncated: '49 Murdock Court',
        address2: 'Brighton Beach, Brooklyn',
        lat: 40.58618,
        lng: -73.96781,
        dates: ['October 1950 – November 1952'],
        mp3: 'My Name Is New York - Location 14 - Preview.mp3',
        mp3Length: '00:00:50',
        imgCredit: 'The Guthrie Family lived here at 49 Murdock Court, Beach Haven Apartment complex in the early 1950s. It was here that Woody witnessed and documented the racist practices by the Beach Haven Apartment Management company run by Fred Trump.',
        description: (
            <div>
                <p>
                    In 1950, The Weavers—founded by former Almanac Singers Pete Seeger and Lee Hays—were the #1 group on the Billboard charts with their recording of Lead Belly’s “Goodnight Irene.” Their next hit record included Woody’s <b>So Long, It’s Been Good To Know Yuh</b> on the B side.
                </p>
                <p>
                    With a large royalty advance, the Guthries could now afford to move out of their tiny Mermaid Avenue apartment and relocate to this red brick apartment building in the Beach Haven development at 49 Murdock Court. Apt. #1J was a $120-a-month, two-bedroom apartment with a large balcony facing Coney Island Hospital. Although Woody continued to pour out songs for his children like <b>Dry Bed</b> and <b>Peejammers I Hate</b>, other songs like <b>Been Down the River Too Long</b> began to take on a more blues-like tone. And <b>Heaven My Home</b>, <b>Love Thyself</b>, and <b>My Name Is New York</b> began to hint at an awareness of mortality…
                </p>
            </div>
        ),
    },
    {
        title: 'Woody and Anneke Guthrie\'s Apartment',
        address: '517 East 5th Street, Apt. #14',
        addressTruncated: '517 East 5th Street',
        address2: 'Lower East Side, Manhattan',
        lat: 40.7246,
        lng: -73.98343,
        dates: ['January – June 1954'],
        mp3: 'My Name Is New York - Location 15 - Preview.mp3',
        mp3Length: '00:00:50',
        imgCredit: 'Anneke Van Kirk and Woody Guthrie, 1953',
        description: (
            <div>
                <p>
                    Woody lived at this location for a few months in 1954 with his third wife, Anneke Van Kirk.  He had met Anneke in 1952, while visiting his old friends Will and Herta Geer, who had moved back to California. Returning to NYC after a trip to Florida, where they had camped out on a tract of land owned by writer, journalist, and activist Stetson Kennedy, Woody and Anneke settled into this apartment on the Lower East Side. Anneke was now pregnant with Woody’s child, Lorina Lynn, who was born at this location in February.
                </p>
                <p>
                    Although Woody experienced moments of hope and bursts of creative energy, it became clear that he was beginning to lose his battle with Huntington’s chorea…
                </p>
            </div>
        ),
    },
    {
        title: 'Brooklyn State Hospital',
        address: '681 Clarkson Avenue (between Albany and Utica Avenues)',
        addressTruncated: '681 Clarkson Avenue',
        address2: 'Flatbush, Brooklyn',
        lat: 40.65633,
        lng: -73.93826,
        dates: ['July – September 1952', 'September 1954 – May 1956', 'Spring 1961 – June 1966'],
        mp3: 'My Name Is New York - Location 16 - Preview.mp3',
        mp3Length: '00:00:58',
        imgCredit: 'Handwritten directions to visit Woody Guthrie at Brooklyn State Hospital, written by Bob Dylan, 1961.',
        description: (
            <div>
                <p>
                    Woody was first admitted to Brooklyn State Hospital in July of 1952, where he was diagnosed with Huntington’s chorea, a disease that he had inherited from his mother, Nora Belle. He would spend the rest of his life in and out of hospitals, including Greystone Park Psychiatric Hospital in New Jersey (1956–1961).
                </p>
                <p>
                    The songs Woody wrote during his various stays at Brooklyn State Hospital and at Greystone Park Psychiatric Hospital, are extraordinary. Struggling against a disease that limited his ability to write or speak, Woody’s songs from this period, like <b>Holy Ground</b>, <b>New Star</b>, <b>Pass Away</b>, and <b>Your Sandal String</b>, exhibit a deep spiritual understanding that defies the traditional boundaries of religion…
                </p>
            </div>
        ),
    },
    {
        title: 'Woody and Marjorie Guthrie\'s House',
        address: '159-13 85th Street',
        addressTruncated: '159-13 85th Street',
        address2: 'Howard Beach, Queens',
        lat: 40.65771,
        lng: -73.84691,
        dates: ['December 1952 – 1967'],
        mp3: 'My Name Is New York - Location 17 - Preview.mp3',
        mp3Length: '00:00:38',
        imgCredit: 'This home at 159-13 85th Street in Howard Beach, Queens is where the Guthrie family lived, while Woody Guthrie was hospitalized with Huntington’s disease.',
        description: (
            <div>
                <p>
                    Marjorie Guthrie and the children moved to this Cape-Cod-style tract house in December 1952. (During the 1960s, this neighborhood became home to many Italian families, including “the Godfather” himself, John Gotti, who lived just down the block).
                </p>
                <p>
                    Although Woody never lived in this house, during the 15 years he was hospitalized with Huntington’s chorea Marjorie continued to care for him, overseeing his years of confinement at the various hospitals and bringing him back to this home on weekends for family gatherings.
                </p>
                <p>
                    Woody Guthrie spent most Sundays here throughout the remaining years of his life…
                </p>
            </div>
        ),
    },
    {
        title: 'Creedmoor State Hospital',
        address: '79-25 Winchester Boulevard',
        addressTruncated: '79-25 Winchester Boulevard',
        address2: 'Queens Village, Queens',
        lat: 40.74138,
        lng: -73.73178,
        dates: ['June 1966 – October 1967'],
        mp3: 'My Name Is New York - Location 18 - Preview.mp3',
        mp3Length: '00:00:52',
        imgCredit: 'Woody Guthrie, 1956',
        description: (
            <div>
                <p>
                    In June 1966, Woody Guthrie was transferred to Creedmoor State Hospital in Queens, where a young doctor, Dr. John Whittier, was Director of Psychiatric Research at the Creedmoor Institute of Psychobiological Studies. He was beginning to research patients with Huntington’s chorea.
                </p>
                <p>
                    Originally diagnosed and named by Dr. George Huntington of East Hampton, Long Island, the disease was briefly described in the mid-1800s by Dr. Charles Oscar Waters of New York as, “A singular convulsive affection… markedly hereditary, and is most common among the lower classes.” In 1916, the disease was traced back to the original carriers who came to Salem and Boston, Massachusetts in the seventeenth century. In 1932, further genetic evidence traced the disease to three men from the village of Bures, England, who it is believed, first came to America on John Winthrop’s ship in the 1600s.
                </p>
                <p>
                    Among Dr. Huntington’s more precise observations was a particularly hopeful note: “If by any chance the children go through life without it, the thread is broken and the grandchildren and great-grandchildren of the original shakers may rest assured that they are free from the disease.”
                </p>
                <p>
                    Woody’s condition was now quickly and seriously deteriorating…
                </p>
            </div>
        ),
    },
    {
        title: 'Atlantic Ocean',
        address: 'West 37th Street, down by the rocks',
        addressTruncated: 'West 37th Street',
        address2: 'Coney Island, Brooklyn',
        lat: 40.57044,
        lng: -74.00196,
        dates: ['October 3, 1967'],
        mp3: 'My Name Is New York - Location 19 - Preview.mp3',
        mp3Length: '00:00:53',
        imgCredit: 'Woody Guthrie’s final resting place, Beach 37th Street, Coney Island, Brooklyn.',
        description: (
            <div>
                <p>
                    Woody’s Final Resting Place
                </p>
                <p>
                    Following his death on October 3, 1967, Marjorie, Arlo, Joady, and Nora Guthrie brought Woody Guthrie’s ashes back to this location on the beach: West 37th Street by the rocks that separate Coney Island from Sea Gate.
                </p>
                <p>
                    This spot had been the “living room” for Woody and Marjorie’s family and held their happiest memories. This is where Marjorie braided Cathy Ann’s hair, sitting on the rocks after her swims. This is where Woody and the kids plunked themselves down on the beach, building sand castles. This is where they sat in the hot summer sun, eating Shatzkin’s knishes and hero sandwiches from Mary’s corner store. This is where they rolled in the waves all those years ago. The family felt that this should be Woody’s final resting place, just down the block from their Mermaid Avenue home…
                </p>
            </div>
        ),
    },
];

export const LOCATION_IMAGES = LOCATIONS.map((location, locationIndex) => {
    const locationNum = locationIndex + 1;

    return {
        src: `./img/locations/Location_${locationNum}_fullsize.webp`,
        thumbnail: `./img/locations/Location_${locationNum}_fullsize-tn.webp`,
    };
});
